import React, { useState, useEffect, useCallback } from 'react';
import { Button, Checkbox, Dialog, DialogContent, DialogHeader, DialogTitle, Table, TableBody, TableCell, TableHead, TableHeader, TableRow, } from '@cargomatic/ui';
import { humanize, titleize } from 'underscore.string';
import formatMoney from 'utils/formatters/Money';
export function RerateCostsDialog({ open, onOpenChange, charges, onRerate, isPending, }) {
    const [checkedIds, setCheckedIds] = useState(new Set());
    useEffect(() => {
        if (open) {
            setCheckedIds(new Set(charges.map((c) => c._id)));
        }
    }, [open, charges]);
    const allChecked = charges.length > 0 && charges.every((c) => checkedIds.has(c._id));
    const handleToggleAll = useCallback((checked) => {
        if (checked) {
            setCheckedIds(new Set(charges.map((c) => c._id)));
        }
        else {
            setCheckedIds(new Set());
        }
    }, [charges]);
    const handleToggle = useCallback((id, checked) => {
        const next = new Set(checkedIds);
        if (checked) {
            next.add(id);
        }
        else {
            next.delete(id);
        }
        setCheckedIds(next);
    }, [checkedIds]);
    return (React.createElement(Dialog, { open: open, onOpenChange: onOpenChange },
        React.createElement(DialogContent, { className: "max-w-2xl" },
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, "Rerate Costs")),
            React.createElement(Table, null,
                React.createElement(TableHeader, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableHead, { className: "w-12" },
                            React.createElement(Checkbox, { checked: allChecked, onCheckedChange: handleToggleAll })),
                        React.createElement(TableHead, null, "Charge"),
                        React.createElement(TableHead, { className: "text-right" }, "Cost"),
                        React.createElement(TableHead, null, "Equipment"))),
                React.createElement(TableBody, null, charges.map((charge) => {
                    var _a, _b;
                    return (React.createElement(TableRow, { key: charge._id },
                        React.createElement(TableCell, null,
                            React.createElement(Checkbox, { checked: checkedIds.has(charge._id), onCheckedChange: (checked) => handleToggle(charge._id, checked) })),
                        React.createElement(TableCell, null, charge.message ||
                            (charge.type ? titleize(humanize(charge.type)) : 'Unknown')),
                        React.createElement(TableCell, { className: "text-right font-medium" }, formatMoney(charge.value)),
                        React.createElement(TableCell, null, (_b = (_a = charge.equipment) === null || _a === void 0 ? void 0 : _a.equipment_id) !== null && _b !== void 0 ? _b : '\u2014')));
                }))),
            React.createElement("div", { className: "flex justify-end gap-2 pt-4" },
                React.createElement(Button, { variant: "outline", onClick: () => onOpenChange(false), disabled: isPending }, "Cancel"),
                React.createElement(Button, { className: "bg-zinc-900 text-white hover:bg-zinc-800", onClick: () => onRerate(Array.from(checkedIds)), disabled: checkedIds.size === 0 || isPending }, isPending ? 'Rerating...' : 'Rerate')))));
}
export default RerateCostsDialog;
